import React from "react";
import { Box } from "@mui/material";

const StrapiHosting1 = ({ src, width, height }) => {
  return (
    <Box
      component="img"
      src="./logos/strapipng.png"
      alt="Strapi Hosting"
      sx={{
        width: width || "100px",
        height: height || "100px",
        objectFit: "contain",
      }}
    />
  );
};

export default StrapiHosting1;

// 35.212.162.221:443
// cname	hosting1	6obdiec2.up.railway.app.